import * as React from 'react';
import { LinkButton } from '@cian/ui-kit';
import { ca } from '@cian/analytics';
import { useIsEditor } from 'shared/utils/editorProvider/editorProvider';
import { useWebviewSingleton } from 'shared/hooks/useWebviewSingleton/useWebviewSingleton';

type TUIKitLinkButtonProps = {
  action: string;
  category: string;
  label: string;
  href: string;
  size: 'L' | 'M' | 'XS';
  hasDeeplink: boolean;
};

export const UIKitLinkButton: React.FC<React.PropsWithChildren<TUIKitLinkButtonProps>> = ({
  action,
  category,
  label,
  href,
  hasDeeplink,
  ...props
}) => {
  const getWebviewSafe = useWebviewSingleton(hasDeeplink);
  const isEditor = useIsEditor();

  const onClick = React.useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      if (isEditor) {
        e.preventDefault();

        return;
      }

      const webview = getWebviewSafe && getWebviewSafe();

      if (webview) {
        e.preventDefault();

        webview.sendAction({
          action: 'open-deeplink',
          payload: { url: href },
        });
      }

      if (category && action && label) {
        ca('eventSite', { category, action, label });
      }
    },
    [action, category, href, isEditor, label, getWebviewSafe],
  );

  //@ts-expect-error на самом деле children есть всегда
  return <LinkButton {...props} href={href} onClick={onClick} />;
};
